export const noReport = json => {
	if (json.root) {
		return {
			type: 'empty-root',
			color: 'IndianRed',
			title: 'Empty Error',
			text: 'A modification installed in your game is preventing proper reporting of errors.',
			description:
				'Nothing can be done to diagnose your error file when it\'s empty.',
		}
	}
}



// WEBPACK FOOTER //
// ./src/tests/noReport.js